import { gql } from "@apollo/client";

import { lensFragment, organizationsFragment } from "../../../shared/api/fragments";

import { type GetLensInfoQuery } from "./getLens.gql-generated";

export type GetLensInfoResponse = GetLensInfoQuery["getLens"];
export type LensInfo = NonNullable<GetLensInfoResponse["lens"]>;

export const getLensInfo = gql`
    query getLensInfo($lensId: ID!, $withOrganizationId: Boolean = false) {
        getLens(input: { lensId: $lensId }) {
            lens {
                ...Lens
                organizationId @include(if: $withOrganizationId)
            }
        }
        getMyLensesOrganizations {
            ...Organizations
        }
    }
    ${lensFragment}
    ${organizationsFragment}
`;

export const getLens = gql`
    query getLens($lensId: ID!) {
        getLens(input: { lensId: $lensId }) {
            lens {
                ...Lens
            }
        }
    }
    ${lensFragment}
`;
